import axios from 'axios';
import React from 'react';
import useSWR from 'swr';

// fetcher
const fetcher = (url: string) => axios.get(url).then(({ data }: any) => data);

// load component data
const withPage: any = (ComponentElement: any) => {
  // render
  return (props: any) => {
    const { id, url }: any = props;
    const { data }: any = useSWR(`${url}/api/v2/pages/${id}`, fetcher);

    // render
    return(<ComponentElement
      data={data}
      {...props} />);
  };
};

export default withPage;